import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { StringInputComponent } from './string-input/string-input.component'
import { CalendarModule } from 'primeng/calendar'
import { TooltipModule } from 'primeng/tooltip'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownInputComponent } from './dropdown-input/dropdown-input.component'
import { DropdownModule } from 'primeng/dropdown'
import { LabelComponent } from './label/label.component'
import { DirectivesModule } from '../../modules/directives/directives.module'
import { MultiselectInputComponent } from './multiselect-input/multiselect-input.component'
import { MultiSelectModule } from 'primeng/multiselect'
import { ProgressComponent } from './progress/progress.component'
import { LogComponent } from './log/log.component'
import { ProgressBarModule } from 'primeng/progressbar'

@NgModule({
  declarations: [
    StringInputComponent,
    DropdownInputComponent,
    LabelComponent,
    MultiselectInputComponent,
    ProgressComponent,
    LogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    InputTextModule,
    ReactiveFormsModule,
    DropdownModule,
    TooltipModule,
    DirectivesModule,
    MultiSelectModule,
    ProgressBarModule
  ],
  exports: [
    StringInputComponent,
    DropdownInputComponent,
    LabelComponent,
    MultiselectInputComponent,
    ProgressComponent,
    LogComponent
  ]
})
export class EditComponentsModule {}
